<template>
  <div class="soar-container flex flex-col gap-y-2">
    <div class="flex flex-col gap-y-4">
      <div class="w-full flex justify-center text-sm md:text-base items-stretch">
        <router-link
          class="flex-1 py-2 px-4 rounded-t-lg text-center"
          :class="[
            matchedRoute.includes('/fees-and-deposits-refund/rejected')
              ? 'bg-primary text-white'
              : 'bg-brand-gray-300 text-black'
          ]"
          to="/fees-and-deposits-refund/rejected"
        >
          {{ $t('feesOfRejectedRequests') }}
        </router-link>
        <router-link
          class="flex-1 py-2 px-4 rounded-t-lg text-center"
          :class="[
            matchedRoute.includes('/fees-and-deposits-refund/deposits')
              ? 'bg-primary text-white'
              : 'bg-brand-gray-300 text-black'
          ]"
          to="/fees-and-deposits-refund/deposits"
        >
          {{ $t('financialDeposits') }}
        </router-link>
        <router-link
          class="flex-1 py-2 px-4 rounded-t-lg text-center"
          :class="[
            matchedRoute.includes('/fees-and-deposits-refund/refund-statistics')
              ? 'bg-primary text-white'
              : 'bg-brand-gray-300 text-black'
          ]"
          to="/fees-and-deposits-refund/refund-statistics"
        >
          {{ $t('statistics') }}
        </router-link>
      </div>
    </div>

    <div class="pt-1">
      <router-view></router-view>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const i18n = useI18n()
const route = useRoute()

const matchedRoute = computed(() => route.matched.map((m) => m.path))
</script>
